// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let TailwindVariants = require("../../bindings/TailwindVariants.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TailwindVariants$1 = require("tailwind-variants");
let ReactAriaComponents = require("react-aria-components");

let radio = TailwindVariants$1.tv({
  extend: TailwindVariants.Utils.focusRing,
  base: "size-[14px] rounded-full border-zinc-300 border bg-white transition-all text-white",
  variants: {
    isSelected: {
      true: "group-pressed:border-gray-500 text-tan-blue-500"
    },
    isInvalid: {
      true: "border-red-700 group-pressed:border-red-800"
    },
    isDisabled: {
      true: "border-gray-200"
    }
  }
});

let groupItem = TailwindVariants$1.tv({
  base: "p-4 flex flex-col items-start cursor-pointer relative border-x",
  variants: {
    isFirst: {
      true: "rounded-t-md border-t"
    },
    isLast: {
      true: "rounded-b-md"
    },
    isSelected: {
      true: "bg-[#F0F8FF] border border-tan-blue-500/35"
    },
    isDisabled: {
      true: "opacity-70 cursor-not-allowed"
    }
  }
});

let Styles = {
  radio: radio,
  groupItem: groupItem
};

function Form__Radio$CircleIcon(props) {
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsx("circle", {
      cx: "6",
      cy: "6",
      fill: "currentColor",
      r: "4"
    }),
    height: "14",
    width: "14",
    viewBox: "0 0 14 14"
  });
}

let CircleIcon = {
  make: Form__Radio$CircleIcon
};

function Form__Radio$RadioGroup(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "flex flex-col gap-2";
  return JsxRuntime.jsx(ReactAriaComponents.RadioGroup, {
    children: props.children,
    className: className,
    name: props.name,
    "aria-label": props.ariaLabel,
    value: props.value,
    onChange: props.onChange
  });
}

let RadioGroup = {
  make: Form__Radio$RadioGroup
};

function Form__Radio$Radio(props) {
  let __renderWrapper = props.renderWrapper;
  let __disabled = props.disabled;
  let __circleClassName = props.circleClassName;
  let __labelClassName = props.labelClassName;
  let label = props.label;
  let labelClassName = __labelClassName !== undefined ? __labelClassName : "";
  let circleClassName = __circleClassName !== undefined ? __circleClassName : "";
  let disabled = __disabled !== undefined ? __disabled : false;
  let renderWrapper = __renderWrapper !== undefined ? __renderWrapper : (param, content) => content;
  return JsxRuntime.jsx(ReactAriaComponents.Radio, {
    value: props.value,
    children: renderProps => renderWrapper(renderProps, JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Form__Radio$CircleIcon, {}),
          className: TailwindMerge.twMerge([
            radio(renderProps),
            circleClassName
          ])
        }),
        label !== undefined ? JsxRuntime.jsx(ReactAriaComponents.Label, {
            children: label,
            className: TailwindMerge.twMerge([
              "cursor-pointer",
              labelClassName
            ])
          }) : null
      ],
      className: "flex items-center gap-2"
    })),
    isDisabled: disabled
  });
}

let Radio = {
  make: Form__Radio$Radio
};

function Form__Radio$RadioCardList$ItemsRenderer(props) {
  let toValue = props.toValue;
  let items = props.items;
  let state = React.useContext(ReactAriaComponents.RadioGroupStateContext);
  let value = state.selectedValue;
  let selectedValueIndex;
  selectedValueIndex = value === null ? -1 : items.findIndex(item => toValue(item.value) === value);
  return items.filter(item => item.skip !== true).map((item, index) => {
    let disabled = Stdlib_Option.getOr(item.disabled, false);
    let isFirst = index === 0;
    let isLast = index === (items.length - 1 | 0);
    let circleClass = disabled ? "border-gray-200" : undefined;
    return JsxRuntime.jsx(Form__Radio$Radio, {
      label: item.title,
      labelClassName: "font-semibold",
      value: toValue(item.value),
      circleClassName: circleClass,
      disabled: disabled,
      renderWrapper: (renderProps, content) => {
        let isDirectlyAboveSelected = selectedValueIndex === (index - 1 | 0);
        let isDirectlyBelowSelected = selectedValueIndex === (index + 1 | 0);
        let selectedStatus = isDirectlyAboveSelected ? "DirectlyAbove" : (
            isDirectlyBelowSelected ? "DirectlyBelow" : "None"
          );
        let overlay = item.overlay;
        let description = item.description;
        return JsxRuntime.jsxs("div", {
          children: [
            content,
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  overlay !== undefined ? JsxRuntime.jsx("div", {
                      children: overlay,
                      className: "whitespace-nowrap bg-tan-gold-light text-white uppercase text-[10px] rounded-[3px] px-1.5 py-0.5 border border-tan-gold-light absolute top-4 right-4"
                    }) : null,
                  description !== undefined ? JsxRuntime.jsx("div", {
                      children: description,
                      className: TailwindMerge.twMerge([
                        "mt-2 mr-6 text-zinc-700",
                        disabled ? "text-zinc-500" : ""
                      ])
                    }) : null
                ],
                className: "flex content-between"
              }),
              className: "w-full ml-[22px]"
            })
          ],
          className: TailwindMerge.twMerge([
            groupItem({
              isFirst: isFirst,
              isLast: isLast,
              isSelected: renderProps.isSelected,
              isDisabled: disabled
            }),
            selectedStatus === "DirectlyBelow" ? "border-b-0" : (
                selectedStatus === "None" ? "border-b" : "border-t-0 border-b"
              )
          ])
        });
      }
    }, toValue(item.value));
  });
}

let ItemsRenderer = {
  make: Form__Radio$RadioCardList$ItemsRenderer
};

function Form__Radio$RadioCardList(props) {
  let onChange = props.onChange;
  let toValue = props.toValue;
  let items = props.items;
  return JsxRuntime.jsx(Form__Radio$RadioGroup, {
    children: JsxRuntime.jsx(Form__Radio$RadioCardList$ItemsRenderer, {
      items: items,
      toValue: toValue
    }),
    name: props.name,
    value: toValue(props.selected),
    onChange: v => {
      let item = items.find(item => toValue(item.value) === v);
      if (item !== undefined) {
        return onChange(item.value);
      }
    },
    className: "flex flex-col gap-0 border-zinc-200 rounded-md overflow-hidden"
  });
}

let RadioCardList = {
  ItemsRenderer: ItemsRenderer,
  make: Form__Radio$RadioCardList
};

function Form__Radio$RadioList(props) {
  let __layout = props.layout;
  let onChange = props.onChange;
  let toValue = props.toValue;
  let items = props.items;
  let layout = __layout !== undefined ? __layout : "Vertical";
  let tmp;
  tmp = layout === "Vertical" ? "flex flex-col gap-3" : "flex flex-row gap-3";
  return JsxRuntime.jsx(Form__Radio$RadioGroup, {
    children: items.filter(item => item.skip !== true).map(item => {
      let disabled = Stdlib_Option.getOr(item.disabled, false);
      let circleClass = disabled ? "border-gray-200" : undefined;
      return JsxRuntime.jsx(Form__Radio$Radio, {
        label: item.label,
        value: toValue(item.value),
        circleClassName: circleClass
      }, toValue(item.value));
    }),
    name: props.name,
    ariaLabel: props.ariaLabel,
    value: toValue(props.selected),
    onChange: v => {
      let item = items.find(item => toValue(item.value) === v);
      if (item !== undefined) {
        return onChange(item.value);
      }
    },
    className: tmp
  });
}

let RadioList = {
  make: Form__Radio$RadioList
};

exports.Styles = Styles;
exports.CircleIcon = CircleIcon;
exports.RadioGroup = RadioGroup;
exports.Radio = Radio;
exports.RadioCardList = RadioCardList;
exports.RadioList = RadioList;
/* radio Not a pure module */
